import {
  HeroSection,
  ProcessSection,
  FeaturesSection,
  ReviewSection,
  FAQSection,
  ProductPageLayout,
} from "./index";

const ProductPagesHOC = (pageConfig) => {
  return (props) => (
    <ProductPageLayout {...pageConfig}>
      {pageConfig.hero && (
        <HeroSection {...pageConfig.hero} theme={pageConfig.theme} />
      )}
      {pageConfig.process && (
        <ProcessSection {...pageConfig.process} theme={pageConfig.theme} />
      )}
      {pageConfig.features && (
        <FeaturesSection {...pageConfig.features} theme={pageConfig.theme} />
      )}

      {pageConfig.reviews && (
        <ReviewSection {...pageConfig.reviews} theme={pageConfig.theme} />
      )}

      {pageConfig.faqs && (
        <FAQSection {...pageConfig.faqs} theme={pageConfig.theme} />
      )}
    </ProductPageLayout>
  );
};

export default ProductPagesHOC;
